import React, { useEffect, useMemo } from 'react';
import PanelLayout from './PanelLayout';
import LeftNavPanel from '../components/LeftNavPanel';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUserAndAdminInitials } from '../utils/GetInitials/GetInitials';
import { InitialFlag } from '../utils/Helper/enums';
import Button from '../library/Button/button';
import AdminTopBar from '../components/TopBar/AdminTopBar';
import { UserDetailProvider } from '../context/UserDetailContext';
import withLogout from '../components/AutoLogOut/withLogout';
import { btAdminRoutes } from '../routes/Routes';
import UserGreeting from '../components/UserGreeting';
import { requestNotificationPermission } from '../firebase';
import { Btadmin } from '../utils/btAdmin';
import { BroadCastMessage } from '../components/BtAdminPanel/broadCastMessage';
import { useAppDispatch } from '../hooks/storeHooks';
import { getAllAdmins, resetPartnerState } from '../store/slice/partnersSlice';
import { getAllPresets, resetPresetState } from '../store/slice/presetSlice';
import { getAllModules, resetModuleState } from '../store/slice/moduleSlice';
import { getAllUsers, resetUsersState } from '../store/slice/userSlice';
import { getAllRepoOwners, resetRepoOwnerState } from '../store/slice/repoOwnerSlice';
import StateSyncStatus from '../components/StateSyncStatus';
import { getAllGitReports, resetGitReportState } from '../store/slice/gitReportSlice';

const BtAdminPanelLayout = () => {
  const dispatch = useAppDispatch();
  const userEmail = sessionStorage.getItem('userEmail') as string;
  const { calculatedInitials, getFullName, getFirstName } = useUserAndAdminInitials(
    userEmail,
    InitialFlag.BtAdmin
  );
  const navigate = useNavigate();

  const tabs = useMemo(
    () => [
      {
        label: 'Home',
        path: btAdminRoutes.dashboard
      },
      {
        label: 'Partner Admins',
        path: btAdminRoutes.partnerAdmin
      },
      {
        label: 'Modules',
        path: btAdminRoutes.modules
      },
      {
        label: 'Repo Owners',
        path: btAdminRoutes.repoOwners
      },
      {
        label: 'Codecommit Analytics',
        path: btAdminRoutes.analytics
      },
      {
        label: 'Preset Configuration',
        path: btAdminRoutes.presets
      },
      {
        label: 'IPP Audit',
        path: btAdminRoutes.audit
      },
      {
        label: 'Reports',
        path: btAdminRoutes.reports
      }
    ],
    []
  );

  const onClick = () => {
    void navigate('/register?btadmin=true');
  };

  useEffect(() => {
    const handleSubscribe = async () => {
      const token = await requestNotificationPermission();
      if (token) {
        const BtAdmin = new Btadmin();
        const response = await BtAdmin.updateNotificationToken(userEmail, token);
      }
    };
    const triggerFetchData = async () => {
      void dispatch(getAllAdmins());
      void dispatch(getAllPresets());
      void dispatch(getAllModules());
      void dispatch(getAllUsers());
      void dispatch(getAllGitReports());
      void dispatch(getAllRepoOwners());
    };
    const clearState = () => {
      void dispatch(resetModuleState());
      void dispatch(resetPartnerState());
      void dispatch(resetPresetState());
      void dispatch(resetUsersState());
      void dispatch(resetGitReportState());
      void dispatch(resetRepoOwnerState());
    };
    void triggerFetchData();
    void handleSubscribe();
    return clearState;
  }, []);

  return (
    <UserDetailProvider
      value={{
        fullName: getFullName,
        firstName: getFirstName,
        calculatedInitials
      }}
    >
      <PanelLayout header={<AdminTopBar btAdmin={true} />} footer={<></>}>
        <LeftNavPanel tabs={tabs} />
        <div className="flex-grow min-w-[350px] overflow-hidden overflow-x-auto transition-all ease-in-out overflow-y-auto px-0 pl-2 sm:px-4 lg:px-4 pb-20">
          <div className="flex justify-between items-end pt-4 pb-2 flex-wrap gap-2">
            <UserGreeting name={getFirstName} isBtAdmin={true} />
            <div className="flex items-center gap-2">
              <div className="flex-1">
                <StateSyncStatus />
              </div>
              <Button
                className="text-[#fff] text-base cursor-pointer bg-black rounded-lg py-2 px-4"
                buttonText="Create Organisation"
                onclick={onClick}
              />
              <BroadCastMessage />
            </div>
          </div>
          <hr />
          <div className="w-full h-fit pb-12">
            <Outlet />
          </div>
        </div>
      </PanelLayout>
    </UserDetailProvider>
  );
};

export default withLogout(BtAdminPanelLayout);
